import { render, staticRenderFns } from "./termsPriceList.vue?vue&type=template&id=378b2e60&scoped=true&"
import script from "./termsPriceList.vue?vue&type=script&lang=js&"
export * from "./termsPriceList.vue?vue&type=script&lang=js&"
import style0 from "./termsPriceList.vue?vue&type=style&index=0&id=378b2e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b2e60",
  null
  
)

export default component.exports